import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "post-meta-image"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "meta_body" }
const _hoisted_4 = {
  key: 0,
  class: "title"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.metaData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "post_meta",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openMetaLink($event)))
      }, [
        (_ctx.metaData.image)
          ? (_openBlock(), _createElementBlock("figure", _hoisted_1, [
              _createElementVNode("img", {
                src: _ctx.metaData.image,
                alt: _ctx.getImageUrl('placeholder_img.png')
              }, null, 8, _hoisted_2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.metaData.siteName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.metaData.siteName), 1))
            : _createCommentVNode("", true),
          (_ctx.metaData.title)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_5, _toDisplayString(_ctx.metaData.title), 1))
            : _createCommentVNode("", true),
          (_ctx.metaData.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.metaData.description), 1))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}